export const scheduleA = (contractor: any) => {
  return [
    { text: 'SCHEDULE A', style: 'h2' },

    { text: 'EQUIPMENT IDENTIFICATION', style: 'p', bold: true },

    { text: 'This Schedule A is an essential part of the Transportation Independent Contractor Agreement (“TICA”) between Company and Independent Contractor.', style: 'p' },

    { text: 'In consideration of Company’s execution of said TICA, Independent Contractor makes the following representations and warranties on which Company will rely. Independent Contractor represents and warrants that it is the registered and/or legal owner of and in lawful possession of the Equipment described below:', style: 'p' },

    { text: `Independent Contractor represents and warrants that the above vehicle meets the requirements set forth in federal and state law and regulations, including 49 CFR 393 and Chapter 2, Title 13 California Code of Regulations, and acknowledges its responsibility in the course and scope of Independent Contractor's own transportation services to maintain a program of inspection, repair and maintenance as set forth in 49 CFR 396 and Chapter 2, Title 13 California Code of Regulations.`, style: 'p' },

    { text: `Independent Contractor further represents and warrants that, if it is domiciled in the State of California, it has made the appropriate filing with the California Highway Patrol pursuant to the Biennial Inspection of Terminals Program of California Vehicle Code (“CVC”) Section 34501.12; maintains the inspection and maintenance records as required by CVC Section 34505.5 and, prior to performing services hereunder will comply with CVC Section 27900 which requires the placement of the identification of the Independent Contractor on the Equipment provided hereunder. Independent Contractor further represents and warrants that, if it is domiciled in the State of California, it has made the appropriate filing in accordance with CVC 34620, et seq.`, style: 'p' },

    { text: `Independent Contractor agrees to provide documentary evidence of its performance of such responsibilities to Company upon reasonable prior notice.`, style: 'p' },

    { text: `In making the above representations and warranties, Independent Contractor understands and agrees that each such representation and/or warranty is an independent material consideration for Company’s execution of the Independent Contractor Agreement and that, should any of such representations prove to be materially false and/or any of such warranties be breached and result in damage of any kind or type to Company, Company may, at its option, terminate the Independent Contractor Agreement forthwith and hold Independent Contractor legally responsible for said damages either by means of setoff against settlements or through legal action.`, style: 'p' },

    {
      columns: [
        {
          width: '50%',
          text: [
            { text: 'COMPANY:', bold: true, color: '#058ff4' },
            { text: '\n' },
            { text: 'Sierra Expediting Inc.', bold: true },
            { text: '\n' },
            { text: 'Signature: ', bold: true },
            { text: '_______________________' },
            { text: '\n' },
            { text: 'Print Name: ', bold: true },
            { text: '_____________________________________' },
            { text: '\n' },
            { text: 'Title: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
            { text: 'Date: ', bold: true },
            { text: '____________________________________________' },
          ],
        },

        {
          width: '50%',

          text: [
            { text: 'INDEPENDENT CONTRACTOR:', bold: true, color: '#058ff4'},
            { text: '\n' },
            { text: `${contractor.name}`, bold: true },
            { text: '\n' },
            { text: 'Signature: ', bold: true },
            { text: '_______________________' },
            { text: '\n' },
            { text: 'Print Name: ', bold: true },
            { text: '_____________________________________' },
            { text: '\n' },
            { text: 'Title: ', bold: true },
            { text: '____________________________________________' },
            { text: '\n' },
            { text: 'Date: ', bold: true },
            { text: '____________________________________________' },
          ],

        },
      ],
      style: 'p',
    },
  ]
}